import React, { useState } from 'react';
import useHandleUserMessage from '../../hooks/useHandleUserMessage';
import {
  NextQuestionContainer,
  NextQuestionContentContainer,
  NextQuestionContentAll,
  NextQuestionItem,
} from '../styled';
import apptracker from '@utils/sensor/apptracker';
import { PROMPT_SUGGEST_QUESTION } from '@src/utils/sensor/track';

export default function NextQuestion({ text, getStream, isLoading }) {
  const [askedList, setAskedList] = useState<string[]>([]);

  const { submitQuestion } = useHandleUserMessage({ getStream });

  const handleSendQuestion = (question) => {
    if (isLoading || askedList.includes(question)) {
      return;
    }
    submitQuestion(question);
    setAskedList([...askedList, question]);
    apptracker(PROMPT_SUGGEST_QUESTION, {
      question,
    });
  };

  return (
    <NextQuestionContainer>
      <NextQuestionContentContainer>
        <NextQuestionContentAll>
          {text.map((question, index) => {
            const wordsList = question.split(' ');
            const middleIndex = Math.ceil(wordsList.length / 2);
            const firstPart = wordsList.slice(0, middleIndex).join(' ');
            const secondPart = wordsList.slice(middleIndex).join(' ');
            const hasAsked = askedList.includes(question);
            return (
              <NextQuestionItem
                className={hasAsked ? 'asked next-question' : 'next-question'}
                key={index}
                onClick={() => {
                  handleSendQuestion(question);
                }}
              >
                {firstPart} <br /> {secondPart}
              </NextQuestionItem>
            );
          })}
        </NextQuestionContentAll>
      </NextQuestionContentContainer>
    </NextQuestionContainer>
  );
}
